<template>
  <div class="wraper">
    <Header :topNav="topNav" @changeTopNav="changeTopNav"> </Header>
    <transition name="slide-left" mode="out-in">
      <router-view
        v-loading="loading"
        ref="userInfo"
        class="inde"
        @changeTopNav="changeTopNav"
      />
    </transition>
    <Footer :ShowBackToTop="ShowBackToTop"></Footer>
  </div>
</template>

<script>
import Header from "./headers/headers.vue";
import Footer from "./footers/footers.vue";
import BlackTo from "@/components/BlackToTop/BlackTo";
export default {
  name: "layout",
  components: {
    Footer,
    Header,
    BlackTo
  },
  data() {
    return {
      topNav: [
        // { id: 1, name: "首页", fun: this.homepage, clicks: true }
        // { id: 2, name: "全部课程", fun: this.allcourse, clicks: false }
        // { id: 3, name: "宠播社区", fun: this.IndustryBBS, clicks: false }
      ],
      ShowBackToTop: false,
      searchInfo: "",
      searchInfo_BBS: "",
      loading: false
    };
  },

  methods: {
    // 回车搜索
    search() {
      if (this.searchInfo != "") {
        // console.log(this.$router.app._route.meta.title);
        // 保存到 vuex
        // console.log(this.searchInfo);
      }
      const info = this.$haveEmoji(this.searchInfo);
      this.$store.commit("header/ADD_SEARCHINFO", info);
    },
    // 回车搜索
    search_BBS() {
      if (this.searchInfo_BBS != "") {
        // 保存到 vuex
        console.log(this.searchInfo_BBS);
      }
      const info = this.$haveEmoji(this.searchInfo_BBS);
      this.$store.commit("header/ADD_SEARCHINFO_BBS", info);
    },
    // 失去焦点
    LoseFocus() {
      this.searchInfo = "";
      this.searchInfo_BBS = "";
    },
    changeTopNav(val) {
      console.log(val, "接收的值");
      for (let i of this.topNav) {
        if (i.name == val) {
          i.clicks = true;
        } else {
          i.clicks = false;
        }
      }
    },
    lazyLoading() {
      const scrollTop = document.documentElement.scrollTop; // 滚动条滚动时，距离顶部的距离
      const windowHeight = document.documentElement.clientHeight; // 可视区的高度
      const scrollHeight = document.documentElement.scrollHeight; // 滚动条的总高度
      // console.log(scrollTop, "dedede==========>>>>>>>>>>>");
      if (scrollTop > 500) {
        this.ShowBackToTop = true;
        // console.log(this.$router.app._route.name);
      } else {
        this.ShowBackToTop = false;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.lazyLoading); // 滚动到底部，再加载的处理事件
  }
};
</script>

<style lang="less">
.whole {
  height: 90vh; /*height可以根据你要创建的页面进行修改*/
  width: 100vw;
  // overflow-x: hidden;
  // overflow-y: scroll;
}
.slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-enter-active {
  transition: all 0.5s ease;
}
.slide-left-leave-to {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.slide-left-leave-active {
  transition: all 0.5s ease;
}
</style>



// WEBPACK FOOTER //
// src/layout_font/index.vue